"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CircularLoader", {
  enumerable: true,
  get: function () {
    return _CircularLoader.CircularLoader;
  }
});
var _CircularLoader = require("./CircularLoader");